export default __webpack_public_path__ + "static/media/gallery_10.d4ce038a.jpg";